import { render, staticRenderFns } from "./AddAdministrator.vue?vue&type=template&id=13495342"
import script from "./AddAdministrator.vue?vue&type=script&lang=js"
export * from "./AddAdministrator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports